import React, { FC } from 'react';

import { Button, Divider, Flex, Form, FormInstance, Input, InputNumber, Select } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { LayoutDirection } from '@app/models/orders';
import { ProjectSelect } from '@components/AntFields';

import { IFormValues } from '../../interfaces';

interface IProps {
  form: FormInstance;
  processUid?: string;
  projectUid?: string;
  onFinish: (values: IFormValues) => void;
}

export const PreviewForm: FC<IProps> = ({ form, onFinish, processUid, projectUid }) => {
  const orderImportsT = useTranslation(NSKeys.orderImports);
  const projectsT = useTranslation(NSKeys.projects);
  const validationT = useTranslation(NSKeys.validation);

  React.useEffect(() => {
    form.setFieldValue('projectUid', projectUid);
  }, []);

  return (
    <Flex vertical gap={15}>
      <Form<IFormValues>
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        initialValues={{
          projectUid,
          // uploaded_file_uid: '',
          // layout: {
          //   direction: 'orders_horizontal',
          //   orders_region: { region_start: 'A4', region_end: '' },
          //   items_region: { region_start: 'aq1', region_end: '', size: 2 },
          // },
        }}>
        <Form.Item<IFormValues> name="uploaded_file_uid" label="uploaded_file_uid" required style={{ display: 'none' }}>
          <Input disabled />
        </Form.Item>
        <Form.Item<IFormValues>
          name={['layout', 'direction']}
          label={orderImportsT.t('previewForm.directionLabel')}
          required
          rules={[
            {
              required: true,
              message: validationT.t('required'),
            },
          ]}>
          <Select
            options={[
              { value: LayoutDirection.OrdersHorizontal, label: orderImportsT.t('previewForm.directionHorizontal') },
              { value: LayoutDirection.OrdersVertical, label: orderImportsT.t('previewForm.directionVertical') },
            ]}
          />
        </Form.Item>
        <Form.Item<IFormValues>
          name="projectUid"
          style={{ minWidth: '150px', margin: 0 }}
          label={projectsT.t('filters.project')}>
          <ProjectSelect
            process_uid={processUid}
            dropdownStyle={{ position: 'fixed' }}
            placeholder={projectsT.t('filters.project')}
          />
        </Form.Item>
        <Divider titlePlacement="left" plain>
          {orderImportsT.t('previewForm.ordersRegionGroupTitle')}
        </Divider>
        <Form.Item<IFormValues>
          name={['layout', 'orders_region', 'region_start']}
          label={orderImportsT.t('previewForm.region_start')}
          required
          rules={[
            {
              required: true,
              message: validationT.t('required'),
            },
          ]}>
          <Input />
        </Form.Item>
        <Form.Item<IFormValues>
          name={['layout', 'orders_region', 'region_end']}
          label={orderImportsT.t('previewForm.region_end')}>
          <Input />
        </Form.Item>
        <Form.Item<IFormValues> name={['layout', 'orders_region', 'size']} label={orderImportsT.t('previewForm.size')}>
          <InputNumber />
        </Form.Item>
        <Divider titlePlacement="left" plain>
          {orderImportsT.t('previewForm.itemsRegionGroupTitle')}
        </Divider>
        <Form.Item<IFormValues>
          name={['layout', 'items_region', 'region_start']}
          label={orderImportsT.t('previewForm.region_start')}
          required
          rules={[
            {
              required: true,
              message: validationT.t('required'),
            },
          ]}>
          <Input />
        </Form.Item>
        <Form.Item<IFormValues>
          name={['layout', 'items_region', 'region_end']}
          label={orderImportsT.t('previewForm.region_end')}>
          <Input />
        </Form.Item>
        <Form.Item<IFormValues> name={['layout', 'items_region', 'size']} label={orderImportsT.t('previewForm.size')}>
          <InputNumber />
        </Form.Item>

        <Button type="primary" htmlType="submit" size="middle" loading={status === 'loading'}>
          {orderImportsT.t('previewButton')}
        </Button>
      </Form>
    </Flex>
  );
};
